import { Box, Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { PageTitle, SectionTitle, Text } from "@jewlr/storybook/info"
import { IS_NA, jewlr_t } from "helpers/application"
import {
  holidayResizeDates as getHolidayResizeDates,
  showHolidayResize,
} from "helpers/holiday"

import VerticalSizeChart from "./ring-sizing/vertical-size-chart"

const SizingTitle = styled(PageTitle)`
  background-size: 0%;
  ${({ theme }) => theme.mediaQueries.tablet`
    background-size: 150px 1px;
  `};
`

const RingSizing = () => {
  const holidayResizeDates = getHolidayResizeDates()
  return (
    <Box textAlign="center">
      <Box contain>
        <Box mb={7} mx={{ _: 3, tablet: 8 }}>
          {showHolidayResize() && (
            <Box mb={{ _: 4, tablet: 7 }}>
              <SectionTitle mb={3}>FREE RESIZING</SectionTitle>
              <Text>
                <strong>
                  For all orders placed after {holidayResizeDates.start}, we
                  have extended our FREE ring resizing period until{" "}
                  {holidayResizeDates.end}. Unsure of the size you need? Use our
                  guide below to determine the correct ring size to order.
                </strong>
              </Text>
              <Text>
                We offer one FREE resizing within two full sizes of your ring,
                including engraved items. Please note there may be an additional
                charge for re-engraving, and you will be responsible for any
                related {jewlr_t("terms.shipping")} costs. If you require a
                resizing of more than two full sizes, or you are beyond the free
                resizing period, we would still be happy to complete your
                resizing for a reasonable fee.
              </Text>
              <Text>
                To have a ring resized, please follow the link to our{" "}
                <Typography
                  as={Link}
                  color="primary"
                  data-lc="ring-sizing"
                  to="/order/resizing"
                >
                  Request Resizing Form
                </Typography>
                .
              </Text>
            </Box>
          )}
        </Box>
      </Box>

      <Box id="size_chart" mb={4}>
        <SizingTitle mb={4} subtitle>
          RING SIZING CHART
        </SizingTitle>
        <VerticalSizeChart />
      </Box>

      {IS_NA() && (
        <Box contain pb={4}>
          <Box mx={{ _: 3, tablet: 8 }}>
            {!showHolidayResize() && (
              <>
                <SectionTitle mb={3}>FREE RESIZING</SectionTitle>
                <Text>
                  We offer one FREE resizing (within 2 full sizes) of your ring
                  within 30 days of the original shipment date. This includes
                  items that have been engraved, though there may be an
                  additional charge for re-engraving. You will also be
                  responsible for any related {jewlr_t("terms.shipping")} cost.
                </Text>
                <Text>
                  If you require a resizing of more than 2 full sizes, or you
                  are beyond the free resizing period, we would still be happy
                  to perform the resize for you, for a reasonable fee.
                </Text>
                <Text>
                  To have a ring resized, please follow the link to our{" "}
                  <Typography
                    as={Link}
                    color="primary"
                    data-lc="ring-sizing"
                    to="/order/resizing"
                  >
                    Request Resizing Form
                  </Typography>
                  .
                </Text>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default RingSizing
